import React from "react";

export default () => (
  <div className="pb5 mb4 f5 center pa4 faq bg-white" style={{ maxWidth: 600 }}>
    <h1>Frequently Asked Questions</h1>
    <div className="mt4 pt2">
      <div>
        <strong>Must i be a graduate to apply?</strong>
        <p>Yes</p>
      </div>

      <div className="mt2">
        <strong>Can i apply for more than one position?</strong>
        <p>No</p>
      </div>

      <div className="mt2">
        <strong>Must i be a Nigerian to apply?</strong>
        <p>Yes</p>
      </div>

      <div className="mt2">
        <strong>Can i apply with a foreign certificate?</strong>
        <p>Yes</p>
      </div>

      <div className="mt2">
        <strong>What is the maximum age to apply?</strong>
        <p>28 years for first degree or HND and 32 years for MSc. </p>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/faq.js